module.exports = "<div class=biv-field data-bind=\"attr: {'data-view': field}\"> <div data-bind=\"text: displayName\" class=biv-field-text></div> <div class=biv-field-value data-bind=\"css: {'biv-field-short': short, 'biv-field-long': long, 'outerdata': outerData}\"> <span data-bind=\"text: text\"></span> <span data-bind=\"visible: hasUnit, text: unit\"></span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/ag-form/view-span/index.html
// module id = 122
// module chunks = 144